
const state = {
  cid: '', // 商户ID
  pathArr: [], // 路径
  isFirstEnter: true, //是否第一次进入商城首页
  isTabbar: false, //tabbar状态
  shoppingCartQty: "0", //购物车数量
  types: [], // 用户标签
  sellerCompanyInfo: {}, //商户信息
  openpurchase: false, //商户开放的购买方式权限
  isscanprice: false, //是否显示商品订货价格
  isscan: '', //是否启用商城开放注册
  permissions: 0, //用户权限 （0=未登录(游客)，1=未审核、2=正常用户）
  qtyDigit: 2, //数量小数点
  priceDigit: 2, //价格小数点
  ticketTypesData: null, //开票信息
  themeFlag: 'happyRed', //主题 happyRed 科技红；blackGold 黑金；technologyBlue 科技蓝
  isHasLoading: false, //是否加载广告，默认不加载
  loadingTime: 1000, //初始进入商城广告时间
  adImg: '../static/img/loading.png', //广告图
  _orderStatus: ['全部', '待审核', '进行中', '已完成', '已中止', '已作废'], //订单状态
  _paymentStatus: ['全部', '未付款', '待确认', '部分付款', '已付款'], //支付状态
  _shippingStatus: ['全部','待发货','部分发货','全部发货'], //发货状态
  _returnStatus: ['全部', '待审核', '待发货', '待收货', '已完成', '已作废'], //退货状态
  _receiptStatus: ['全部', '待商家收款', '商家已收款', '已作废', '支付失败'], //收款单状态
  _salesRebateStatus: ['全部', '待确认', '待审核', '已审核'], //采购返点状态
  _advanceWithdrawStatus: ['全部', '待支付', '已支付'], //采购返点状态
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js